/**
 * @file src/pages/invoice-management-hub/components/SortableHeader.jsx
 * @description Clickable column header with a sort indicator.
 *
 * Pure presentational — parent owns the sort state and decides what
 * happens on click via the onSort prop.
 */

import React from "react";
import Icon from "components/AppIcon";

const SortableHeader = ({ label, sortKey, currentSort, onSort }) => (
  <button
    onClick={() => onSort(sortKey)}
    className="flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-colors"
  >
    {label}
    <Icon
      name="ArrowUpDown"
      size={14}
      className={
        currentSort.key === sortKey ? "text-primary" : "text-muted-foreground"
      }
    />
  </button>
);

export default SortableHeader;